jQuery(window).on("load", function () {

    if ($("header .menu").offset().top > 100) {
        setTimeout(function () {
            $('header .menu').addClass('menu-up menu-down');
        }, 100);
    };

    $('.info-slider, .info-slider-img, .collection-block .slider, .objects .img-wrap').css('opacity', '1');

    function addClassToSliderBefore() {
        $('.slick-slide').removeClass('prev next');
        //$('.slick-current').addClass('prev');
        $('.slick-current').next().next().addClass('next');
    }

    function addClassToSliderAfter() {
        $('.slick-slide').removeClass('prev next');
        $('.slick-current').prev().addClass('prev');
        $('.slick-current').next().addClass('next');
    }

    function getTitle() {
        var titlePrev = $('.prev .text').data('title');
        var titleNext = $('.next .text').data('title');
        var titleLeft = $('.collection-block .title-l span');
        var titleRight = $('.collection-block .title-r span');

        var size = 32;

        if (titlePrev.length > size) {
            titleLeft.text(titlePrev.slice(0, size) + ' ...');
        } else {
            titleLeft.text(titlePrev)
        }
        if (titleNext.length > size) {
            titleRight.text(titleNext.slice(0, size) + ' ...');
        } else {
            titleRight.text(titleNext)
        }
    }

    $('.slick-current').prev().addClass('prev');
    $('.slick-current').next().addClass('next');

    if ($('.collection-block').length > 0) {
        getTitle();
    }

    $('.collection-block .slider').on('beforeChange', function (slick, currentSlide) {
        addClassToSliderBefore();

    });
    $('.collection-block .slider').on('afterChange', function (slick, currentSlide) {
        addClassToSliderAfter();
        getTitle();
    });

    $('.slider-counter').prependTo($('.first-block .wrap'));

    $('.collection-block .slick-prev').prependTo($('.collection-block .count'));
    $('.collection-block .slick-next').appendTo($('.collection-block .count'));
    $('.collection-block .slick-prev').clone().prependTo($('.collection-block .slick-wrap'));
    $('.collection-block .slick-next').clone().appendTo($('.collection-block .slick-wrap'));
    $('.collection-block .slick-wrap .slick-prev').click(function () {
        $('.collection-block .count .slick-prev').click();
    })
    $('.collection-block .slick-wrap .slick-next').click(function () {
        $('.collection-block .count .slick-next').click();
    })

    $('.slider-about .slick-prev').prependTo($('.slider-wrap .count'));
    $('.slider-about .slick-next').appendTo($('.slider-wrap .count'));
    $('.slider-wrap .slick-prev').clone().prependTo($('.slider-about'));
    $('.slider-wrap .slick-next').clone().appendTo($('.slider-about'));
    $('.slider-about .slick-prev').click(function () {
        $('.slider-wrap .count .slick-prev').click();
    })
    $('.slider-about .slick-next').click(function () {
        $('.slider-wrap .count .slick-next').click();
    })

    $('.collection-block .slick-wrap .slick-prev').hover(function () {
        $('.title-l').css('background-color', 'rgba(235,59,59,.9)');
    }, function () {
        $('.title-l').css('background-color', 'rgba(28,29,35,.5)');
    });

    $('.collection-block .slick-wrap .slick-next').hover(function () {
        $('.title-r').css('background-color', 'rgba(235,59,59,.9)');
    }, function () {
        $('.title-r').css('background-color', 'rgba(28,29,35,.5)');
    });

    $('#carouselExampleControls').on('slide.bs.carousel', function (event) {
        if (event.direction == "left") {
            $('.info-slider-img .slick-next').click();
        } else if (event.direction == "right") {
            $('.info-slider-img .slick-prev').click();
        }
    })

    var maxHeight = 0;
    var highestElement = {};
    $('.carousel-item').each(function () {
        var thisHeight = $(this).height();
        if (thisHeight > maxHeight) {
            maxHeight = thisHeight;
        }
    });
    $('.carousel-item').css('height', maxHeight);

    setTimeout(function () {

        var contentImg = $('.content .img-wrap').height();
        var contentText = $('.content .title span').width($('.content img').height());

        var size = 30,
            newsContent = $('.content .title span'),
            newsText = newsContent.text();

        if (newsText.length > size) {
            newsContent.text(newsText.slice(0, size) + ' ...');
        }

    }, 100);

    $('#donateModal .copy').on("click", function (event) {
        tmp = $("<textarea>");
        $("body #donateModal").append(tmp);
        var text = $(this).parents('.item').find('span').text();
        tmp.val(text).select();
        document.execCommand("copy");
        tmp.remove();
        $(this).attr('data-title', $(this).attr('data-title-end'));
    });

    $("#donateModal .copy").mouseleave(function () {
        $(this).attr('data-title', $(this).attr('data-title-start'));
    });

    var widthProgress = ($('.progress-bar').attr('aria-valuenow') / $('.progress-bar').attr('aria-valuemax')) * 100;
    $('.progress-bar').css('width', widthProgress + '%');

    $('.modal').on('hidden.bs.modal', function (e) {
        $('.menu').removeClass('open');
        $('header').removeClass('open');
    })
    $('.modal').on('show.bs.modal', function (e) {
        if ($('.menu').hasClass('menu-down')) {
            $('header').addClass('open');
            $('.menu').addClass('open trans');
        }
    })

    $('.objects .btn').click(function () {

    })

    function sizeText(size, newsContent) {
        var size = size,
            newsContent = newsContent;
        for (var i = 0; i < newsContent.length; i++) {
            newsText = $(newsContent[i]).text();
            if (newsText.length > size) {
                $(newsContent[i]).text(newsText.slice(0, size) + ' ...');
            }
        }
    }
    sizeText(45, $('.news-block .text-wrap h2 a'));
    sizeText(175, $('.news-block .text-wrap p'));
    sizeText(45, $('.objects .title'));
    sizeText(215, $('.objects .text p'));

    function heightImg(newsImg, textWrap, imgWrap) {
        var newsImg = newsImg,
            textWrap = textWrap,
            imgWrap = imgWrap;
        for (i = 0; i < newsImg.length; i++) {
            var tempHeight = $(newsImg.find(textWrap)[i]).outerHeight();
            $(newsImg.find(imgWrap)[i]).height(tempHeight);
        }
    }
    setTimeout(function () {
        heightImg($('.news-block .item'), '.text-wrap', '.img-wrap');
        //heightImg($('.objects .item'), '.text', '.slick-slide');
        //        for (var i = 0; i < $('.objects .item img').length; i++) {
        //            console.log($('.objects .item img')[i])
        //        }
        //        var maxHeightImg = 0;
        //        var highestElementImg = {};
        //        $('.objects .item img').each(function () {
        //            var thisHeightImg = $(this).height();
        //            if (thisHeightImg > maxHeightImg) {
        //                maxHeightImg = thisHeightImg;
        //            }
        //        });
    }, 70);

    $('.dropdown-menu li').click(function () {
        $('.dropdown-menu li').removeClass('active');
        $(this).addClass('active');
        $(this).parents('.dropdown').find('button').text($(this).text());
    })
    var maxHeightSliderFor, maxHeightSliderNav;
    $('.lodge-modal').on('shown.bs.modal', function (e) {
        $('.slider-for').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            infinite: false,
            asNavFor: '.slider-nav'
        });
        $('.slider-nav').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: false,
            asNavFor: '.slider-for',
            focusOnSelect: true
        });

        //        var tempImgFor = $('.slider-for img');
        //        var arrFor = [];
        //        for (var i = 0; i < tempImgFor.length; i++){
        //            arrFor.push($(tempImgFor[i]).height()); 
        //        }
        //        maxHeightSliderFor = Math.max.apply(null, arrFor);
        //        var tempImgNav = $('.slider-nav img');
        //        var arrNav = [];
        //        for (var i = 0; i < tempImgNav.length; i++){
        //            arrNav.push($(tempImgNav[i]).height()); 
        //        }
        //        maxHeightSliderNav = Math.max.apply(null, arrNav);
        //        console.log('maxHeightSliderNav', maxHeightSliderNav);
        //        $('.slider-for').css('height', maxHeightSliderFor);
        //        $('.slider-nav').css('height', maxHeightSliderNav);

        setTimeout(function () {
            $('.slider-for, .slider-nav').css({
                'opacity': '1',
                'height': 'auto'
            });
        }, 50);
    })

    $('.lodge-modal').on('hidden.bs.modal', function (e) {
        $('.slider-for, .slider-nav').slick('unslick');
        $('.lodge-modal textarea').hide();
        $('.lodge-modal form button').text($('.lodge-modal form button').attr('data-submit'));
        $('.lodge-modal form button').attr('type', 'button');
        $('.lodge-modal .close').removeClass('show');
        $('textarea').val('')
        $('.slider-for').css({
            'opacity': '0',
            'height': '484px'
        });
        $('.slider-nav').css({
            'opacity': '0',
            'height': '130px'
        });
        if ($(window).width() < 992 && $(window).width() > 767.99) {
            $('.slider-nav').css('height', '170px');
        } else if ($(window).width() < 767) {
            $('.slider-for').css('height', '324px');
            $('.slider-nav').css('height', '80px');
        }
    })

    $('.lodge-modal form button.btn').click(function () {
        $('.lodge-modal textarea').fadeIn();
        $('.lodge-modal .close').addClass('show');
        $(this).text($(this).attr('data-send'));
        setTimeout(function () {
            $('.lodge-modal form button.btn').attr('type', 'submit');
        }, 50);
    })

    $('.lodge-modal .close').click(function () {
        setTimeout(function () {
            $('.lodge-modal form button.btn').text($('.lodge-modal form button.btn').attr('data-submit'));
            $('.lodge-modal form button.btn').attr('type', 'button');
        }, 50);
        $('.lodge-modal textarea').hide();
        $(this).removeClass('show');
        $('textarea').val('')
    })

    $('.lodge-modal form').validate({
        submitHandler: function (form) {
            $('.lodge-modal form').ajaxSubmit({
                clearForm: true,
                success: function (data) {
                    if (data == 'success') {
                        $('.toast-body').css('color', '#28a745');
                        $('.toast-body').text($('.lodge-modal form').data('success'));
                        $('.toast').toast('show');
                        $('.lodge-modal form').trigger('reset');
                    } else {
                        $('.toast-body').css('color', '#f1202d');
                        $('.toast-body').text($('.lodge-modal form ').data('error'));
                        $('.toast').toast('show');
                        console.log(data);
                    }
                },
                error: function () {
                    $('.toast-body').css('color', '#f1202d');
                    $('.toast-body').text($('.lodge-modal form ').data('error'));
                    $('.toast').toast('show');
                }
            });
        }
    });

});

$(document).ready(function () {

    /*------------------COMMON-------------------*/

    $("#menu").mmenu({
        "extensions": [
                "position-left",
                "pagedim-black",
                "border-offset"
             ],
        classNames: {
            fixedElements: {
                fixed: "fix-menu"
            },
            vertical: "expand"
        }
    });

    $("#menu").mhead();

    var api = $('#menu').data('mmenu');
    api.bind("close:finish", function () {
        $('.icon').removeClass('open');
    });
    
    $("nav .scroll").click(
        function (evnt) {
            api.close();
            $('.icon').removeClass('open');
        }
    );

    [].forEach.call(document.querySelectorAll('img[data-src]'), function (img) {
        img.setAttribute('src', img.getAttribute('data-src'));
        img.onload = function () {
            img.removeAttribute('data-src');
        };
    });
    
    if ($(window).width() < 992) {
        $('.number').click(function () {
            $('body,html').animate({
                scrollTop: $('.acc').offset().top - 10
            }, 800);
        })
    }

    if ($(window).width() < 1200) {
        var lastScrollTop = 0;
        $(window).scroll(function (event) {
            var st = $(this).scrollTop();
            if (st > $(window).height()) {
                $('.fix-menu').addClass('mh-scrolledout');
            } else {
                $('.fix-menu').removeClass('mh-scrolledout');
            }
            if (st > lastScrollTop) {
                $('.fix-menu').addClass('menu-down');
            } else if (st == 0) {
                $('header').removeClass('menu-down');
            } else {
                $('.fix-menu').removeClass('mh-scrolledout');
            }

            lastScrollTop = st;

        });



    } else {
        var heightHeader = $('header .info').height() + 12;
        var lastScrollTop = 0;

        $(window).scroll(function (event) {
            var st = $(this).scrollTop();
            $('.menu').removeClass('trans');
            if (st > $(window).height()) {
                $('header .menu').addClass('menu-up');
            } else {
                $('header .menu').removeClass('menu-up');
            }
            if (st > heightHeader) {
                $('header .menu').addClass('menu-down');
            } else {
                $('header .menu').removeClass('menu-down');
            }
            if (st < lastScrollTop) {
                $('header .menu').removeClass('menu-up');
            }

            /*if (st > $(window).height()) {
                $('header').addClass('menu-up');
            } else {
                $('header').removeClass('menu-up');
            }
            if (st > heightHeader) {
                $('header').addClass('menu-down');
            } else {
                $('header').removeClass('menu-down');
            }
            if (st < lastScrollTop) {
                $('header').removeClass('menu-up');
            }*/

            lastScrollTop = st;
        });
    };

    var location = window.location.href;
    var cur_url = location.split('/').pop();
    $('header ul li').each(function () {
        var link = $(this).find('a').attr('href');

        if (cur_url == link) {
            $(this).addClass('current');
        }
    });

    $('.mm-listitem a').each(function () {
        var link = $(this).attr('href');
        if (cur_url == link) {
            $(this).addClass('current');
        }
    });

    $('.scroll').on("click", function (event) {
        var anchor = event.target.hash;
        if (anchor) {
            if ($(anchor).length) {
                event.preventDefault();
                $('body,html').animate({
                    scrollTop: $(anchor).offset().top
                }, 800);
            }
        }
    });

    /*$(".arrow-up").click(function () {
        $('html, body').animate({
            scrollTop: 0
        }, 700);
    });

    $(window).scroll(function (event) {
        var st = $(this).scrollTop();
        if (st > $(window).height()) {
            $('.arrow-up').addClass('show');
        } else {
            $('.arrow-up').removeClass('show');
        }
    });*/

    $('.jarallax').jarallax({
        speed: 0.2
    });

    jQuery('textarea').autoResize();

    $('.lang.mm-listitem a').each(function () {
        var link = $(this).attr('href');
        if (cur_url == link) {
            $(this).addClass('current');
        }
    });

    /*------------------COMMON-END-------------------*/

    $('.panel-heading').click(function () {
        $(this).parent().toggleClass('active');
        $('.panel-heading').not(this).parent().removeClass('active');
        $(this).toggleClass('open').next().slideToggle();
        $('.panel-heading').not(this).removeClass('open').next().slideUp();
        $('.number').removeClass('active');
        var num = $(this).parent().index();
        if ($(this).hasClass('open')) {
            $('.number').removeClass('active');
            $('.number').eq(num).addClass('active');
        } else {
            $('.number').removeClass('active');
        }
    });

    $('.number').click(function () {
        if ($(this).hasClass('active')) {
            $('.number').removeClass('active');
        } else {
            $('.number').removeClass('active');
            $(this).addClass('active');
        }
        var num = $(this).text()
        $('.panel-heading').eq(num - 1).parent().toggleClass('active');
        $('.panel-heading').not($('.panel-heading').eq(num - 1)).parent().removeClass('active');
        $('.panel-heading').eq(num - 1).toggleClass('open').next().slideToggle();
        $('.panel-heading').not($('.panel-heading').eq(num - 1)).removeClass('open').next().slideUp();
    })

    $('.video .img-wrap').click(function () {
        $(this).hide();
        $('video').trigger('play');
    })



    function sizeVideo() {
        var videoWidth = $('.video video').width();
        var videoHeight = $('.video video').height();
        $('.video .img-wrap').width(videoWidth + 5);
        $('.video .img-wrap').height(videoHeight + 18);
    }
    //sizeVideo();

    $('.payment-form').css('margin-top', -$('.payment-form h1').outerHeight());

    window.addEventListener("orientationchange", function () {
        sizeVideo();
    }, false);

    $(window).resize(function () {
        sizeVideo();
    });

    /*------------------SLIDER-------------------*/

    function initSliderInfo() {
        var slider = $('.info-slider-img');

        if (slider.length) {
            var currentSlide;
            var slidesCount;
            var sliderCounter = document.createElement('div');
            sliderCounter.classList.add('slider-counter');

            var updateSliderCounter = function (slick, currentIndex) {
                currentSlide = slick.slickCurrentSlide() + 1;
                slidesCount = slick.slideCount;

                if (slidesCount < 10) {
                    $('.counter1').text('0' + currentSlide);
                    $('.counter2').text('0' + slidesCount);
                } else {
                    $('.counter1').text(currentSlide);
                    $('.counter2').text(slidesCount);
                }

            };

            slider.on('init', function (event, slick) {
                slider.append(sliderCounter);
                updateSliderCounter(slick);
            });

            slider.on('afterChange', function (event, slick, currentSlide) {
                updateSliderCounter(slick, currentSlide);
            });

            //            slider.slick({
            //                slidesToShow: 1,
            //                infinite: false,
            //                asNavFor: '.info-slider-img',
            //                autoplay: true,
            //                autoplaySpeed: 8000,
            //                responsive: [
            //                    {
            //                        breakpoint: 576,
            //                        settings: {
            //                            slidesToShow: 1
            //                        }
            //                    }
            //                  ]
            //            });

            slider.slick({
                lazyLoad: 'ondemand',
                slidesToShow: 1,
                infinite: true,
                arrows: true,
                fade: true,
                swipe: false,
                responsive: [
                    {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                  ]
            });
        }
    }
    initSliderInfo();


    function initSliderCollection() {
        var collectionSlider = $('.collection-block .slider');

        if (collectionSlider.length) {
            var currentSlide;
            var slidesCount;
            var sliderCounter = document.createElement('div');
            sliderCounter.classList.add('slider-counter');

            var updateSliderCounter = function (slick, currentIndex) {
                currentSlide = slick.slickCurrentSlide() + 1;
                slidesCount = slick.slideCount;

                if (slidesCount < 10) {
                    $('.count1').text('0' + currentSlide);
                    $('.count2').text('0' + slidesCount);
                } else {
                    $('.count1').text(currentSlide);
                    $('.count2').text(slidesCount);
                }

            };

            collectionSlider.on('init', function (event, slick) {
                collectionSlider.append(sliderCounter);
                updateSliderCounter(slick);
            });

            collectionSlider.on('afterChange', function (event, slick, currentSlide) {
                updateSliderCounter(slick, currentSlide);
            });

            collectionSlider.slick({
                lazyLoad: 'ondemand',
                centerMode: true,
                centerPadding: '310px',
                slidesToShow: 1,
                autoplay: true,
                autoplaySpeed: 7000,
                responsive: [
                    {
                        breakpoint: 1930,
                        settings: {
                            centerPadding: '310px',
                        }
                    },
                    {
                        breakpoint: 1700,
                        settings: {
                            centerPadding: '229px',
                        }
                    },
                    {
                        breakpoint: 1500,
                        settings: {
                            centerPadding: '129px',
                        }
                    },
                    {
                        breakpoint: 1200,
                        settings: {
                            centerMode: false,
                            centerPadding: '50px'
                        }
                    }
                  ]
            });

        }
    }
    initSliderCollection();

    function initSliderAbout() {
        var collectionSlider = $('.slider-about');

        if (collectionSlider.length) {
            var currentSlide;
            var slidesCount;
            var sliderCounter = document.createElement('div');
            sliderCounter.classList.add('slider-counter');

            var updateSliderCounter = function (slick, currentIndex) {
                currentSlide = slick.slickCurrentSlide() + 1;
                slidesCount = slick.slideCount;

                if (slidesCount < 10) {
                    $('.count1').text('0' + currentSlide);
                    $('.count2').text('0' + slidesCount);
                } else {
                    $('.count1').text(currentSlide);
                    $('.count2').text(slidesCount);
                }

            };

            collectionSlider.on('init', function (event, slick) {
                collectionSlider.append(sliderCounter);
                updateSliderCounter(slick);
            });

            collectionSlider.on('afterChange', function (event, slick, currentSlide) {
                updateSliderCounter(slick, currentSlide);
            });

            collectionSlider.slick({
                slidesToShow: 1,
                infinite: false,
                //                autoplay: true,
                //                autoplaySpeed: 7000
            });

        }
    }
    initSliderAbout();

    $('.objects .img-wrap').slick({
        slidesToShow: 1,
        infinite: false,
        fade: true
        /*autoplay: true,
        autoplaySpeed: 3000,*/
    });


    //    $('.slider-about').slick({
    //        slidesToShow: 1,
    //        /*autoplay: true,
    //        autoplaySpeed: 3000,*/
    //        responsive: [
    //            {
    //                breakpoint: 576,
    //                settings: {
    //                    slidesToShow: 1
    //                }
    //                }
    //              ]
    //    });



    //    $('.info-slider').slick({
    //        slidesToShow: 1,
    //        infinite: false,
    //        /*autoplay: true,
    //        autoplaySpeed: 3000,*/
    //        responsive: [
    //            {
    //                breakpoint: 576,
    //                settings: {
    //                    slidesToShow: 1
    //                }
    //            }
    //          ]
    //    });

    //    $('.collection-block .slider').slick({
    //        centerMode: true,
    //        centerPadding: '300px',
    //        slidesToShow: 1,
    //        /*autoplay: true,
    //        autoplaySpeed: 3000,*/
    //        responsive: [
    //            {
    //                breakpoint: 1700,
    //                settings: {
    //                    centerPadding: '220px',
    //                }
    //            },
    //            {
    //                breakpoint: 1500,
    //                settings: {
    //                    centerPadding: '120px',
    //                }
    //            },
    //            {
    //                breakpoint: 1200,
    //                settings: {
    //                    centerMode: false,
    //                    centerPadding: '50px'
    //                }
    //            }
    //          ]
    //    });




    /*------------------SLIDER-END-------------------*/

    /*------------------FORM-------------------*/

    $('.contact-block form').validate({
        submitHandler: function (form) {
            $('.contact-block form').ajaxSubmit({
                clearForm: true,
                success: function (data) {
                    if (data == 'success') {
                        $('.toast-body').css('color', '#28a745');
                        $('.toast-body').text($('.contact-block form').data('success'));
                        $('.toast').toast('show');
                        $('.contact-block form').trigger('reset');
                    } else {
                        $('.toast-body').css('color', '#f1202d');
                        $('.toast-body').text($('.contact-block form ').data('error'));
                        $('.toast').toast('show');
                    }
                },
                error: function () {
                    $('.toast-body').css('color', '#f1202d');
                    $('.toast-body').text($('.contact-block form ').data('error'));
                    $('.toast').toast('show');
                }
            });
        }
    });


    //    $('#donateModal .copy').click(function () {
    //        var $tmp = $("<textarea>");
    //        $("body").append($tmp);
    //        $tmp.val($(this).parent().find('span').text()).select();
    //        document.execCommand("copy");
    //        $tmp.remove();
    //    })


    /*------------------FORM-END-------------------*/

    //Swedbank Payment switched to EveryPay
    $('.amount-btn').click(function () {
        $('#input-amount').val($(this).data('amount'));
        return false;
    });

    $.urlParam = function(name){
        var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
        return results[1] || 0;
    }

    $('#SwedbankModal form').validate({
        submitHandler: function (form) {
            $('.spp-loading').css('display', 'flex');
            $('#SwedbankModal form').ajaxSubmit({
                clearForm: true,
                success: function (data) {
                    var res = jQuery.parseJSON(data);
                    if (res.payment_state === 'initial') {
                        window.location.href = res.payment_link;
                    } else {
                        window.location.href = 'donate-error.html';
                    }
                },
                error: function (data) {
                    window.location.href = 'donate-error.html';
                }
            });
        }
    });

    $('.lodge-btn').on('click', function () {
        $('#lodgeModal').modal('show');
        $.ajax({
            type: "POST",
            data: 'action=lodge&id=' + $(this).data('id'),
            success: function (data) {
                var json = $.parseJSON(data);
                $('#lodgeModal .title').text(json[0]);
                $('#lodgeModal .country').text(json[1]);
                $('#lodgeModal .descr').html(json[2]);
                $('#lodgeModal .slider-for img').remove();
                $('#lodgeModal .slider-nav img').remove();
                $.each(json[3], function (index, value) {
                    $('#lodgeModal .slider-for').append('<img src="/media/' + value + '" alt="' + json[0] + '">');
                    $('#lodgeModal .slider-nav').append('<img src="/media/' + value + '" alt="' + json[0] + '">');
                });
                $('#lodgeModal').modal('show');
                console.log(data);
            }
        });
    });

    var payment_reference = '';
    if ($('.payment-page').length > 0) {
        payment_reference = $.urlParam('payment_reference');
        if (payment_reference) {
            $.ajax({
                url: '/actions/payment.php',
                type: "POST",
                data: {payment_reference: payment_reference},
                success: function (data) {
                    var res = JSON.parse(data);
                    if (res['payment_state'] === 'failed') window.location.href = 'donate-error.html';
                }
            });
        }
    }
});
